import "./inline-select.scss";
import * as React from "react";

type Props = {
    options: Array<React.ReactNode>;
    selected: number;
    onSelect: (index: number) => void;
    className?: string;
};

type State = {};

export default class InlineSelect extends React.Component<Props, State> {
    public render(): React.ReactNode {
        return (
            <div className="inline-select">
                {this.props.options.map((option, index) => {
                    const classes = [ "inline-select-option" ];

                    if(index === this.props.selected) {
                        classes.push("selected");
                    }

                    if(this.props.className) {
                        classes.push(this.props.className);
                    }

                    return (
                        <div
                            className={classes.join(" ")}
                            key={index}
                            onClick={(): void => this.props.onSelect(index)}
                        >
                            {option}
                        </div>
                    );
                })}
            </div>
        );
    }
}
